import React from 'react';
import useLazyImage from '../hooks/useLazyImage';

/**
 * Optimized lazy loading component specifically for small flag images
 * @param {Object} props - Component props
 * @param {string} props.src - Flag image source URL
 * @param {string} props.alt - Alt text (country code)
 * @param {Object} props.style - Inline styles
 * @returns {JSX.Element} Lazy loaded flag image
 */
const LazyFlag = ({ src, alt = '', style = {}, ...props }) => {
  const { imageSrc, isLoaded, imageRef, handleImageLoad, handleImageError } = useLazyImage(
    src, 
    '', // No placeholder for flags - they're small
    {
      rootMargin: '150px', // Load flags a bit earlier since they're small
      threshold: 0.1
    }
  );

  const flagStyle = {
    opacity: isLoaded ? 1 : 0,
    transition: 'opacity 0.2s ease',
    ...style
  };

  return (
    <span ref={imageRef} style={{ display: 'inline-block' }}>
      {imageSrc && (
        <img
          src={imageSrc}
          alt={alt}
          style={flagStyle}
          onLoad={handleImageLoad}
          onError={handleImageError}
          loading="lazy"
          decoding="async"
          {...props}
        />
      )}
    </span>
  );
};

export default React.memo(LazyFlag);